import { useTranslation } from 'react-i18next';
import { POS_CATEGORY_COLORS } from '@/constants/posCategoryIcons';

interface Props {
  value?: string | null;
  onChange: (color: string) => void;
}

export default function ColorPicker({ value, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-8 lg:grid-cols-10 gap-2">
        {POS_CATEGORY_COLORS.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => onChange(color)}
            title={color}
            className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full border-2 transition-transform ${
              value === color ? 'border-gray-900 scale-110' : 'border-transparent hover:scale-105'
            }`}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
      <div className="flex items-center gap-2 pt-1">
        <span className="text-xs text-gray-500">{t('common.custom')}</span>
        <input
          type="color"
          value={value || '#cccccc'}
          onChange={(e) => onChange(e.target.value)}
          className="w-8 h-8 p-0 border-0 rounded cursor-pointer"
        />
        <span className="text-xs text-gray-500 font-mono">{value || ''}</span>
      </div>
    </div>
  );
}
